import { useEffect } from "react";
import axios from "axios";

const Logout = () => {
    useEffect(() => {
        (async () => {
         try {
           const {data} = await  
                 axios.post(`${global.config.live_url}/logout/`,{
                 refresh_token:localStorage.getItem('refresh_token')
                 } ,{headers: {'Content-Type': 'application/json'}},  
                 {withCredentials: true});
           //localStorage.clear();
           localStorage.removeItem("access_token")
           localStorage.removeItem("user_id")
           localStorage.removeItem("access")
           localStorage.removeItem("refresh_token")
           axios.defaults.headers.common['Authorization'] = null;
           window.location.href = '/'
           } catch (e) {
             console.log('logout not working', e)
           }
         })();
        
    }, []);
    
    return <div></div>;
}
export default Logout;